import React from "react";
import PropTypes from "prop-types";

import Stack from "@mui/material/Stack";

const FormContent = (props) => {
  const { children } = props;

  const style = {
    display: "flex",
    padding: "0 24px",
    flexDirection: "column",
    alignItems: "flex-start",
    gap: "16px",
    alignSelf: "stretch",
  };

  return <Stack sx={style}>{children}</Stack>;
};

FormContent.propTypes = {
  children: PropTypes.any.isRequired,
};

export default FormContent;
